import React from 'react'
import { makeStyles, Typography, Button, Grid } from '@material-ui/core'
import { withRouter } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
   successContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: theme.spacing(0, 2)
   },
   image: {
      width: '50%',
      height: 'auto',
      marginBottom: theme.spacing(2)
   },
   title: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '22px',
      lineHeight: '19px',
      color: '#013F8C',
      marginTop: theme.spacing(2),
      textAlign: 'center'
   },
   content: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '-0.05px',
      color: '#9EA0A5',
      marginBottom: theme.spacing(2)
   },
   acceptButton: {
      margin: theme.spacing(3, 0, 2, 0),
      color: '#FFF'
   }
}))

function SuccessMessage({ history, type }) {
   const classes = useStyles()

   function onAccept() {
      history.push('/auth/login')
   }

   return (
      <Grid className={classes.successContainer}>
         <Typography className={classes.title}>
            {type === 'requestPasswordReset' && '¡Email Enviado!'}
            {type === 'resetPassword' && '¡Contraseña Asignada!'}
            {type === 'userIsUpdated' && '¡Datos actualizados exitosamente!'}
         </Typography>
         <img alt="Éxito" src="/static/success.png" className={classes.image} />
         <Grid>
            {type === 'requestPasswordReset' && (
               <>
                  <Typography className={classes.content}>
                     Para restablecer su contraseña, por favor haz clic en el
                     mensaje de{' '}
                     <strong>
                        Asunto: Portal ZonaSER - Recuperar Contraseña
                     </strong>
                     , y sigue las instrucciones dadas.
                  </Typography>
                  <Typography className={classes.content}>
                     No olvides revisar la carpeta de Correos no Deseados.
                  </Typography>
               </>
            )}
            {type === 'resetPassword' && (
               <Typography className={classes.content}>
                  Su contraseña ha sido restablecida exitosamente.
               </Typography>
            )}
            {type === 'userIsUpdated' && (
               <Typography className={classes.content}>
                  Para asignar tu contraseña de acceso al portal,{' '}
                  <strong>
                     por favor revisa la notificación en la bandeja de entrada
                     de tu correo electrónico
                  </strong>
                  ; si no lo encuentras, revisa la bandeja de correos no
                  deseados.
               </Typography>
            )}
         </Grid>
         <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={onAccept}
            disableElevation
            className={classes.acceptButton}
         >
            INICIAR SESIÓN
         </Button>
      </Grid>
   )
}

export default withRouter(SuccessMessage)
